import type { OpenExternalUrlRequestPayload, OpenRequestPayload } from '@sdk/payload.types'

/**
 * Open a file in the CatalogIQ instance.
 */
export function open(payload: OpenRequestPayload = {}): Promise<string> {
  return this.API.request('open', payload)
}

/**
 * Open external URL in a new tab. Works on both web and mobile.
 */
export function openExternalUrl(payload: OpenExternalUrlRequestPayload): Promise<void> {
  return this.API.request('open_external_url', payload)
}
